import { CSSProperties, ImgHTMLAttributes } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { StyledTitle } from 'components/StyledTitle';

export type TextLevelType = 0 | 1 | 2 | 3 | 4 | 5;

export interface TitleProps extends ImgHTMLAttributes<HTMLImageElement> {
  title: string;
  icon?: string;
  level: TextLevelType;
  iconStyle?: CSSProperties;
}

type LeveledTextProps = {
  level: TextLevelType;
  title: string;
};

const { Text } = Typography;
const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;
`;

const LeveledText = ({ level, title }: LeveledTextProps): JSX.Element => {
  return level === 0 ? (
    <Text>{title}</Text>
  ) : (
    <StyledTitle level={level} margin="0">
      {title}
    </StyledTitle>
  );
};

const IconTitle = ({ title, icon, level, ...props }: TitleProps): JSX.Element => (
  <TitleContainer {...props}>
    {icon && <img style={props.iconStyle} alt={`icon-${title.replace(' ', '-')}`} src={icon} />}
    <LeveledText level={level} title={title} />
  </TitleContainer>
);

export default IconTitle;
